const pageNameKey = "enableDisableAllBlueprintDashboardToggles";

export const enableDisableAllBlueprintDashboardTogglesEn = {
  [pageNameKey]: {
    enableAllToggles: "Enable All Toggles",
    divider: " / ",
    disableAllToggles: "Disable All Toggles",
    explaination: "To show the last available data or the latest data",
  },
};

export const enableDisableAllBlueprintDashboardTogglesPtBr = {
  [pageNameKey]: {
    enableAllToggles: "Ativar todas as alternâncias",
    divider: " / ",
    disableAllToggles: "Desativar todos os controles deslizantes",
    explaination:
      "Para mostrar os últimos dados disponíveis ou os dados mais recentes",
  },
};

export const enableDisableAllBlueprintDashboardTogglesDe = {
  [pageNameKey]: {
    enableAllToggles: "Aktivieren Sie alle Schalter",
    divider: " / ",
    disableAllToggles: "Deaktivieren Sie alle Schalter",
    explaination:
      "So zeigen Sie die letzten verfügbaren Daten oder die neuesten Daten an",
  },
};

export const enableDisableAllBlueprintDashboardTogglesZhHans = {
  [pageNameKey]: {
    enableAllToggles: "启用所有切换",
    divider: " / ",
    disableAllToggles: "禁用所有切换",
    explaination: "显示最后可用数据或最新数据",
  },
};

export const enableDisableAllBlueprintDashboardTogglesIt = {
  [pageNameKey]: {
    enableAllToggles: "Attiva tutti gli interruttori",
    divider: " / ",
    disableAllToggles: "Disattiva tutti gli interruttori",
    explaination:
      "Per visualizzare i dati più recenti disponibili o l'ultimo dato disponibile",
  },
};

export const enableDisableAllBlueprintDashboardTogglesEs = {
  [pageNameKey]: {
    enableAllToggles: "Activar todos los interruptores",
    divider: " / ",
    disableAllToggles: "Desactivar todos los interruptores",
    explaination:
      "Mostrar los últimos datos disponibles o los datos más recientes",
  },
};

export const enableDisableAllBlueprintDashboardTogglesNl = {
  [pageNameKey]: {
    disableAllToggles: "Deactiveer alle schakelaars",
    divider: " / ",
    enableAllToggles: "Activeer alle schakelaars",
    explaination: "Zo toont u de laatst beschikbare of meest recente gegevens",
  },
};

export const enableDisableAllBlueprintDashboardTogglesTr = {
  [pageNameKey]: {
    disableAllToggles: "Tüm Geçişleri Devre Dışı Bırak",
    divider: "/",
    enableAllToggles: "Tüm Geçişleri Etkinleştir",
    explaination: "Mevcut en son verileri veya en son verileri göstermek için",
  },
};
